// extracted by mini-css-extract-plugin
export default {"service":"rUZLiDBxHzoEuwfsHATe","button":"EwNH6y2_06pceZ6XuCOA"};